module.exports = __webpack_public_path__ + "img/lottery.a883aabe.png";